export default __webpack_public_path__ + "static/media/cur.1fcc5ce6.jpg";